import React, { Component } from 'react';

class Sheet extends Component {
    radioRef = React.createRef();

    handlePassValue = (event) => {
        const radioRef = this.radioRef;
        this.props.onSheetSelect(radioRef);
    };

    render() {
        return (
            <label for={this.props.info.id} className="sheet-num" onClick={this.handlePassValue}>
                <input ref={this.radioRef} type="radio" name="sheet-check" id={this.props.info.id} value={this.props.info.id} className="d-none sheet-input" />
                <span className="select-num d-inline-block">{this.props.info.examNum}</span>
                <span className="exam-text">{this.props.info.text}</span>
            </label>
        );
    }
}

export default Sheet;